import { createStyles } from "@mantine/core";

export const useStyle = createStyles(() => ({
  modalContent: {
    padding: "0px 30px",
  },
  warning: {
    color: "red",
    marginBottom: "15px",
  },
  button: {
    display: "flex",
    justifyContent: "center",
  },
}));
